(function() {
    'use strict';

    angular
        .module('app.principal')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/principal',
                config: {
                    templateUrl: 'app/principal/principal.html'
                }
            }
        ];
    }
})();
